module.exports = __webpack_public_path__ + "img/marian-kroell-kAS1HkvoeZU-unsplash.cc5dd402.jpg";